export const permissionsKeys = {
  customerService: 'customer-service',
};
